<template>
    <div class="component-wrap">
        <van-dropdown-menu class="h06-py-cinema-area-select">
            <van-dropdown-item :title="currentCountyName" ref="dropdownMenu">
                <div class="area_content">
                    <div class="fc-tips" style="padding-bottom: 10px;padding-top: 27px;">区域</div>
                    <div class="area_list">
                        <span v-for="(item, index) in countyList" :key="index" class="txt-ellipsis" :class="currentCountyName === item.name ? 'active' : ''" @click="selectCounty(item)">
                            {{item.name}}
                        </span>
                    </div>
                </div>
            </van-dropdown-item>
            <!-- <van-dropdown-item title="筛选">
                <div class="area-content">123</div>
            </van-dropdown-item>
            <van-dropdown-item title="综合排序">
                <div class="area-content">123</div>
            </van-dropdown-item> -->
        </van-dropdown-menu>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    data() {
        return {
            countyList: [],
            // extendIcon: [
            //     require("./static/extend_grey.png"),
            //     require("./static/collapse_red.png"),
            // ]
        }
    },
    watch: {
        'currentCityCode': {
            handler() {
                this.getCountyList();
            }
        }
    },
    mounted() {
        this.getCountyList();
    },
    methods: {
        selectCounty(item) {
            if (this.currentCountyName !== item.name) {
                this.$store.commit('setSelectedCounty', item);
                this.$emit('change', true);
                this.$refs.dropdownMenu.toggle(false);
            }
        },
        getCountyList() {
            let params = {
                citycode: this.currentCityCode
            }

            this.$service.getCountyList(params).then(res => {
                var county_list = []
                if(res && res.data && res.data.countyList) {
                    county_list = res.data.countyList
                } else {
                    budo_log.info("#64 county_list", res, params)
                }

                county_list.unshift({ name: '全城' })
                this.countyList = county_list;
            })
        }
    },
    computed: {
        ...mapGetters([
            'currentCityCode',
            'currentCountyName'
        ]),
    },
    beforeDestroy() {
        // budo_log.info('#71 销毁了组件')
        // this.$store.commit('setSelectedCounty', null);
    }
}
</script>

<style lang="scss" scoped>
.component-wrap {
	background-color: #fff;
	color: #3f4956;
	border-top: 1px solid #eff1f8;
	/deep/ .van-dropdown-menu__title {
		font-size: 12px;
        padding: 0 15px;
        &::after {
            border-color: transparent transparent #3D4957 #3D4957;
            right: 0;
        }
	}
    /deep/ .van-dropdown-menu__bar {
        box-shadow: 0px 0px 0px;
        height: 40px;
        .van-dropdown-menu__item {
            justify-content: start;
        }
    }
	.area_content {
		padding: 0 12px;
		.area_list {
            display: grid;
            grid-template-columns: repeat(3, 30%);
            justify-content: space-between;
			span {
				width: 100px;
				height: 30px;
				line-height: 30px;
				padding: 0 10px;
				background-color: #f5f5f7;
				color: #333;
				border-radius: 4px;
				text-align: center;
				margin: 8px 0;
			}
			span.active {
				color: #f4657d;
				background-color: #fff5f5;
			}
		}
	}
}
</style>
